<template>
  <div class="breadcrump-wrapper">
    <v-breadcrumbs
      v-if="!noBreadcrumbs"
      large
      :items="breadcrumbItems"
    >
      <template v-slot:divider>
        <v-icon>mdi-chevron-left</v-icon>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions, mapGetters } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'NajBreadcrumb',
  computed: {
    noBreadcrumbs() {
      return Boolean(this.$route.meta.noBreadcrumbs);
    },
    ...mapState(['breadcrumbs']),
    ...mapGetters(['finalRoutes']),
    params() {
      return this.breadcrumbs.params;
    },
    formattedValue(route) {
      return route.meta.breadcrumbs.linkText(this.value);
    },
    loadingText(route) {
      const loadingText = route.meta.breadcrumbs.loadingText;
      return loadingText || 'Loading...';
    },
    breadcrumbItems() {
      const dashboardUrl = window.location.origin + '/applications/dashboard';
      if ((this.breadcrumbs.data || []).some(b => b.onBase)) {
        const isBankruptcy = (this.breadcrumbs.data || []).some(b => b.isBankruptcy);
        if (isBankruptcy) {
          return [
            {
              text: this.local.breadcrumbs.home,
              href: dashboardUrl,
            },
            {
              text: this.local.breadcrumbs.bankruptcy,
              href: process.env.VUE_APP_PUBLIC_PATH + '/bankruptcy',
            },
            ...this.breadcrumbs.data,
          ];
        } else {
          return [
            {
              text: this.local.breadcrumbs.home,
              href: dashboardUrl,
            },
            ...this.breadcrumbs.data,
          ];
        }
      }
      return [
        {
          text: this.local.breadcrumbs.home,
          href: dashboardUrl,
        },
        {
          text: this.local.breadcrumbs.judgement,
          to: '/',
        },
        ...this.breadcrumbs.data,
      ];
    },
  },
  watch: {
    $route(newRoute) {
      this.clearBreadcrumbsData();
      this.prepareBreadcrumbs(newRoute.matched);
    },
  },
  mounted() {
    this.clearBreadcrumbsData();
    this.prepareBreadcrumbs(this.$route.matched);
  },
  methods: {
    ...mapActions(['clearBreadcrumbsData', 'updateBreadcrumbs']),
    getRouteGetter(route) {
      if (route.meta.breadcrumbs.getter) {
        return this.$store.getters[route.meta.breadcrumbs.getter];
      } else {
        return null;
      }
    },
    returnUrlPathArray(path) {
      return path
        .replace(/\//g, ':')
        .split(':')
        .filter(item => item);
    },
    isValidNodeId(nodeId) {
      let finalRoute = null;
      if (this.finalRoutes) {
        finalRoute = this.finalRoutes?.find(item => item.id == nodeId);
      }
      return finalRoute;
    },
    replaceParamsWithValues(path) {
      const urlArray = this.returnUrlPathArray(path);
      const lastParam = this.$route.params[urlArray[urlArray.length - 1]];
      if (!isNaN(lastParam) && !this.isValidNodeId(lastParam)) {
        return '#';
      }
      const url = urlArray
        .map((item) => {
          return this.$route.params[item] ? this.$route.params[item] : item;
        })
        .join('/');
      return '/' + url;
    },
    prepareBreadcrumbs(matchedRoutes) {
      const currentRoute = this.$route;
      matchedRoutes.reduce((breadcrumbs, route) => {
        const breadcrumbsMeta = route.meta.breadcrumbs;
        let text = null;
        let to = null;
        const pathArray = route.path.split('/');
        const paramName = Object.keys(currentRoute.params).length
          ? pathArray[pathArray.length - 1].replace(':', '')
          : null;
        if (breadcrumbsMeta) {
          to = this.replaceParamsWithValues(route.path);
          text =
            breadcrumbsMeta.text ||
            this.$store.getters[breadcrumbsMeta.getter](currentRoute.params[paramName]);
          if (text) {
            this.updateBreadcrumbs({
              params: currentRoute.params,
              data: {
                exact: false,
                text,
                to,
                onBase: breadcrumbsMeta.onBase,
                isBankruptcy: breadcrumbsMeta.isBankruptcy,
                disabled: to == '#',
                getter: breadcrumbsMeta.getter,
              },
            });
            return breadcrumbs.concat({
              exact: false,
              text,
              to,
              disabled: to == '#',
              onBase: breadcrumbsMeta.onBase,
              isBankruptcy: breadcrumbsMeta.isBankruptcy,
              getter: breadcrumbsMeta.getter,
            });
          }
        }
        return breadcrumbs;
      }, []);
    },
  },
};
</script>
<style lang="scss">
.breadcrump-wrapper {
  line-height: 1;
  .v-breadcrumbs {
    & > li {
      &.v-breadcrumbs__divider {
        color: #97aead;
        font-weight: bold;
      }

      & > a.v-breadcrumbs__item.v-breadcrumbs__item--disabled {
        color: #044e58;
        opacity: 1;
        font-size: 28px;
        font-weight: bold;
      }
      & > a.v-breadcrumbs__item {
        font-size: 19px;
        color: var(--app-dark-primary-color);
        @media (max-width: 1680px) {
          font-size: 17px;
        }
      }
    }
  }
}
</style>
